import { Column, LinearProgress, Row } from 'components/Blocks';
import { Coin } from 'components/DecorativeIcons';

import { appConfig } from 'config/app';
import { useUser } from 'providers/Auth';

import { RedeemButton } from 'components/Rewards';

import { useLang } from 'locale';

interface IncentiveProgressProps {
  showRedeemButton?: boolean;
}

export function IncentiveProgress({ showRedeemButton = true }: IncentiveProgressProps) {
  const { t } = useLang();
  const { activeIncentive } = useUser();

  const progress = Math.min((activeIncentive / appConfig.minimumRedemption) * 100, 100);

  return (
    <Column>
      <Row gap="3">
        <Coin size={40} />

        <strong className="text-3xl font-semibold text-foreground-title">{activeIncentive}</strong>

        <span className="-ml-1 text-lg font-medium text-foreground-light">
          / {appConfig.minimumRedemption}
        </span>

        <span className="-ml-2 text-lg font-medium text-foreground-light">{t('points')}</span>
      </Row>

      <LinearProgress value={progress} trackClassName="bg-grad-gold" className="h-5 border" rounded>
        <span className="absolute right-1.5 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-white" />
      </LinearProgress>

      {showRedeemButton && (
        <RedeemButton
          className="rounded-full disabled:cursor-crosshair disabled:bg-muted-foreground"
          size="large"
        />
      )}
    </Column>
  );
}
